var $ff8aa6518e51f809$exports = {};
$ff8aa6518e51f809$exports = {
    "dismiss": `Zignoruj`
};


export {$ff8aa6518e51f809$exports as default};
//# sourceMappingURL=pl-PL.mjs.map
